// extracted by mini-css-extract-plugin
export var homepageAboutContent = "homepageAbout-module--homepage-about-content--Qilol";
export var homepageAboutWrap = "homepageAbout-module--homepage-about-wrap--pZkGf";